import React from 'react';
const INK = '#01332b';
const SKIN = '#FBF7F0';
const GREEN = '#05DD4D';
interface FigureProps {
  className?: string;
}
export function YoungestFigure({
  className = ''
}: FigureProps) {
  return <svg viewBox="0 0 120 148" className={className} role="img" aria-label="Stylised illustration of an energetic, spontaneous youngest sibling" data-id="element-63" data-mp="2spegsyxj2582">
      <ellipse cx="60" cy="140" rx="20" ry="3.5" fill={INK} opacity="0.16" data-id="element-64" data-mp="201a804jntc15" />

      {/* motion arcs */}
      <path d="M22 104 q-6 -12 0 -24" fill="none" stroke="#A1D4FD" strokeWidth="3" strokeLinecap="round" data-id="element-65" data-mp="250dabh89945f" />
      <path d="M98 104 q6 -12 0 -24" fill="none" stroke="#A1D4FD" strokeWidth="3" strokeLinecap="round" data-id="element-66" data-mp="29xvdeqzlcp5i" />

      <g transform="rotate(7 60 88)" data-id="element-67" data-mp="3levdi8s6k8a3">
        {/* arms up in a V */}
        <path d="M42 82 L24 60" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-68" data-mp="3lgppgxlh4q21" />
        <path d="M78 82 L96 60" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-69" data-mp="3qbvazvays2pl" />

        {/* legs mid-jump */}
        <path d="M52 116 L44 126 L33 128" fill="none" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-70" data-mp="j30gxwgib6ec" />
        <path d="M70 116 L79 125" fill="none" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-71" data-mp="a3dbmzknpgg0" />

        {/* torso */}
        <rect x="40" y="70" width="40" height="48" rx="17" fill={GREEN} stroke={INK} strokeWidth="3" data-id="element-72" data-mp="6s68d4q63bn" />

        {/* head */}
        <circle cx="60" cy="50" r="16" fill={SKIN} stroke={INK} strokeWidth="3" data-id="element-73" data-mp="3mmwhi63hldj5" />
        <path d="M44 46 q2 -16 16 -16 q14 0 16 16 l-6 -8 -4 6 -5 -8 -5 7 -5 -5 -7 8 z" fill={INK} data-id="element-74" data-mp="3ilay01wg60zz" />
        <circle cx="54" cy="50" r="2.3" fill={INK} data-id="element-75" data-mp="3dkvlfcjzoxj2" />
        <circle cx="66" cy="50" r="2.3" fill={INK} data-id="element-76" data-mp="38mlr1463a0yi" />
        <path d="M53 57 q7 9 14 0 z" fill={INK} data-id="element-77" data-mp="38n3twjn9bdfe" />
      </g>

      {/* sparkles */}
      <path d="M14 62 l2.5 5 5 2.5 -5 2.5 -2.5 5 -2.5 -5 -5 -2.5 5 -2.5 z" fill={GREEN} data-id="element-78" data-mp="2yxwx3qgfij8k" />
      <path d="M104 74 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2 z" fill="#01332b" data-id="element-79" data-mp="33zdsj6g59dhr" />
      <path d="M92 28 l1.8 3.6 3.6 1.8 -3.6 1.8 -1.8 3.6 -1.8 -3.6 -3.6 -1.8 3.6 -1.8 z" fill={GREEN} data-id="element-80" data-mp="2p2d1z69ovokv" />
    </svg>;
}